import * as keyboardActions from './actions';
import {Record} from 'immutable';

const State = Record({
    focusId: null,
    position: null
});

const FOCUS_ID = 'focusId';
const POSITION = 'position';

const keyboardReducer = (state = new State(), action) => {

    switch (action.type) {
        case keyboardActions.SET_FOCUS_ID: {
            const {id} = action.payload;
            return state.set(FOCUS_ID, id);
        }

        case keyboardActions.RESET_POSITION: {
            return state.set(POSITION, false);
        }

        case keyboardActions.SET_FIRST_KEY: {
            return state.set(POSITION, true);
        }
    }

    return state;
};

export default keyboardReducer;



// WEBPACK FOOTER //
// ./src/common/components/keyboard/reducer.js